'use client'

import * as React from 'react'
import { useNotifications } from '@repo/notifications/use-notifications'
import { useQueryClient } from '@tanstack/react-query'
import { useUserCoinBalanceQuery } from 'codegen/generated/coins'
import { invalidateSessionListAndCoinBalance } from './invalidate-session-list-and-coin-balance'
import { mediaMatrixContentProcessedEvent } from './media-matrix-notification-event'
import { isFinishedContent } from './session-list-refresh'

type NotificationEvent = NonNullable<Parameters<typeof useNotifications>[0]['event']>

export function useRefreshSessionListOnContentDone(queryRootKey: string, serviceType: string) {
  const queryClient = useQueryClient()
  const event = React.useMemo(() => mediaMatrixContentProcessedEvent(serviceType), [serviceType])

  useNotifications({
    event,
    onNotification: notification => {
      const broadcast = notification.studio?.studioMediaMatrix?.contentProcessedBroadcast
      if (!isFinishedContent(broadcast)) {
        return
      }
      invalidateSessionListAndCoinBalance(
        queryClient,
        queryRootKey,
        useUserCoinBalanceQuery.getKey(),
      )
    },
  })
}

export function useRefreshSessionListOnDone(event: NotificationEvent, queryRootKey: string) {
  const queryClient = useQueryClient()

  useNotifications({
    event,
    onNotification: () => {
      invalidateSessionListAndCoinBalance(
        queryClient,
        queryRootKey,
        useUserCoinBalanceQuery.getKey(),
      )
    },
  })
}
